import { createContext, useState } from 'react';

import Flex from './Flex';
import Label from './Label';
import * as styles from '@/styles/components/FormControl';

type FormControl = {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  invalid?: boolean;
  maxLength?: number | undefined;
  children: React.ReactNode;
  required?: boolean;
  helperTextTop?: boolean;
  helperTextFontSize?: string;
  sublabel?: string;
  isWidthFull?: boolean;
};

type FormControlContext = {
  invalid: boolean;
  setCount: React.Dispatch<React.SetStateAction<number>>;
};

export const FormControlContext = createContext<FormControlContext>({
  invalid: false,
  setCount: () => {},
});

const FormControl = ({
  label = '',
  helperText = '',
  errorMessage = '',
  invalid = false,
  maxLength = undefined,
  required = false,
  helperTextTop = false,
  helperTextFontSize = '1.2rem',
  children,
  sublabel = '',
  isWidthFull = true,
}: FormControl) => {
  const [count, setCount] = useState(0);

  return (
    <div className={isWidthFull ? 'uk-width-full' : ''}>
      {label && <Label label={label} required={required}></Label>}
      {!!helperText && helperTextTop && (
        <div css={styles.message(helperTextFontSize)}>
          <div className='uk-margin-small-bottom'>
            {/* ヘルパー */}
            {!invalid && helperText && helperTextTop && <div css={styles.helperText}>{helperText}</div>}
          </div>
        </div>
      )}
      <FormControlContext.Provider value={{ invalid, setCount }}>
        {sublabel ? (
          <Flex alignItems='center' gap={8}>
            {children}
            <div>{sublabel}</div>
          </Flex>
        ) : (
          <>{children}</>
        )}
      </FormControlContext.Provider>

      {/* メッセージ系 */}
      {(!!helperText || !!errorMessage || maxLength) && (
        <div css={styles.message(helperTextFontSize)}>
          <div>
            {/* ヘルパー */}
            {!invalid && helperText && !helperTextTop && <div css={styles.helperText}>{helperText}</div>}
            {/* エラー */}
            {invalid && <div css={styles.errorMessage}>{errorMessage}</div>}
          </div>

          {/* 文字数 */}
          {maxLength && (
            <div css={invalid && count > maxLength ? styles.lengthOver : null}>
              {count}/{maxLength}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FormControl;
